import { connect } from 'react-redux';
import TransformCanvas from '../components/Configurator/TransformCanvas';
import { setConfig, setActiveImage, setActiveText } from '../actions/actionCreators/configurator';
import { resetTransformArea, setImage } from '../actions/actionCreators/transformArea';

function mapStateToProps(state) {
    const lib3d = b4w.require('Library3D');
    const {
        config,
        customizationType,
        printableAreas,
        engravingAreas,
        disabledAreas,
    } = state.configurator;
    const { image, text, container, containerType, isOpen } = state.transformArea;
    const backgroundColor = lib3d.getParentColor(container.name);

    return {
        image,
        text,
        container,
        containerType,
        isOpen,
        config,
        customizationType,
        printableAreas,
        engravingAreas,
        disabledAreas,
        backgroundColor,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setConfig: config => dispatch(setConfig(config)),
        resetTransformArea: () => dispatch(resetTransformArea()),
        setActiveImage: image => dispatch(setActiveImage(image)),
        setActiveText: text => dispatch(setActiveText(text)),
        setImage: image => dispatch(setImage(image)),
    };
}

const TransformCanvasContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TransformCanvas);

export default TransformCanvasContainer;
